import { useMutation } from '@tanstack/react-query';
import { BackendRoute } from 'consts';
import { useCallback } from 'react';
import apiService from 'services/api.service';
import { EventInvitationResponse, EventResponse } from 'types';

export const useInvitation = () => {
  const acceptInvitation = useCallback(async (invitationToken: string) => {
    const response = await apiService.post<EventInvitationResponse>(
      {
        endpoint: BackendRoute.ACCEPT_INVITATION,
      },
      {
        queryParams: {
          invitationToken,
        },
      },
    );

    return response;
  }, []);

  const acceptInvitationMutation = useMutation<EventInvitationResponse, Error, string>({
    mutationFn: acceptInvitation,
  });

  const rejectInvitation = useCallback(async (invitationToken: string) => {
    const response = await apiService.post<EventResponse[]>(
      {
        endpoint: BackendRoute.REJECT_INVITATION,
      },
      {
        queryParams: {
          invitationToken,
        },
      },
    );

    return response;
  }, []);

  const rejectInvitationMutation = useMutation<EventResponse[], Error, string>({
    mutationFn: rejectInvitation,
  });

  return {
    acceptMutation: acceptInvitationMutation,
    rejectMutation: rejectInvitationMutation,
  };
};
